import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { HomeTypeFailure, HomeTypeRequest, HomeTypeSuccess } from './actions';
import { HomeTypeService } from './service';

@Injectable()
export class HomeTypeEffects {
  private readonly actions$ = inject(Actions);
  private readonly homeTypeService = inject(HomeTypeService);

  homeType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HomeTypeRequest),
      switchMap(({ parameters }) =>
        this.homeTypeService.homeType(parameters).pipe(
          map(data => HomeTypeSuccess({ data })),
          catchError(error => of(HomeTypeFailure({ error })))
        )
      )
    )
  );

}
